export default __webpack_public_path__ + "static/media/Viriyah.255172b9.png";